export default class WorkflowManifestCompilationError extends Error {
    constructor(errors) {
        super('Workflow manifest cannot be compiled because it is invalid')

        this.name = 'WorkflowManifestCompilationError'
        this.code = 'INVALID_FLOW_MANIFEST'
        this.errors = errors
    }
}
